import { AdminNewsRoles } from './AdminNewsRoles';
import { CatalogsAbrogationReasons } from './CatalogsAbrogationReasons';
import { CatalogsChecklistAnswerTypes } from './CatalogsChecklistAnswerTypes';
import { CatalogsErknmCountries } from './CatalogsErknmCountries';
import { CatalogsErknmDecisionPassportKnmDocumentTypes } from './CatalogsErknmDecisionPassportKnmDocumentTypes';
import { CatalogsErknmKnmDocumentTypes } from './CatalogsErknmKnmDocumentTypes';
import { CatalogsErknmKnmPlanReasonChangeTypes } from './CatalogsErknmKnmPlanReasonChangeTypes';
import { CatalogsErknmKnmRejectReasonTypes } from './CatalogsErknmKnmRejectReasonTypes';
import { CatalogsErknmKnmResponsibleTypes } from './CatalogsErknmKnmResponsibleTypes';
import { CatalogsErknmPlannedActivities } from './CatalogsErknmPlannedActivities';
import { CatalogsErknmPunishmentNature } from './CatalogsErknmPunishmentNature';
import { CatalogsInteractionCategory } from './CatalogsInteractionCategory';
import { CatalogsJudgmentAllCancellationInformation } from './CatalogsJudgmentAllCancellationInformation';
import { CatalogsJudgmentAllCourtLevels } from './CatalogsJudgmentAllCourtLevels';
import { CatalogsJudgmentAllPunishmentIndex } from './CatalogsJudgmentAllPunishmentIndex';
import { CatalogsJudgmentEnabledCourts } from './CatalogsJudgmentEnabledCourts';
import { CatalogsKnmAccessLevel } from './CatalogsKnmAccessLevel';
import { CatalogsKnmActType } from './CatalogsKnmActType';
import { CatalogsKnmCanceledReason } from './CatalogsKnmCanceledReason';
import { CatalogsKnmDocumentTypes } from './CatalogsKnmDocumentTypes';
import { CatalogsKnmPlanTypes } from './CatalogsKnmPlanTypes';
import { CatalogsKnmRejectReasonTypesId } from './CatalogsKnmRejectReasonTypesId';
import { CatalogsKnmRemarks } from './CatalogsKnmRemarks';
import { CatalogsKnmTypes } from './CatalogsKnmTypes';
import { CatalogsNkoForeignAgentsId } from './CatalogsNkoForeignAgentsId';
import { CatalogsRfDistricts } from './CatalogsRfDistricts';
import { CurrentExtendedprofile } from './CurrentExtendedprofile';
import { DecisionPassportFindIndexes } from './DecisionPassportFindIndexes';
import { DecisionPassportId } from './DecisionPassportId';
import { DecisionPassportIdHistory } from './DecisionPassportIdHistory';
import { isDecisionPassportIdIsCanBeSigned } from './IsDecisionPassportIdIsCanBeSigned';
import { DictionariesAcceptedDocument } from './DictionariesAcceptedDocument';
import { DictionariesConstraintGetAllKnmReasonTypes } from './DictionariesConstraintGetAllKnmReasonTypes';
import { DictionariesCheckList } from './DictionariesCheckList';
import { DictionariesConstraintGetAvailableApplicationConditions } from './DictionariesConstraintGetAvailableApplicationConditions';
import { DictionariesConstraintGetEventUuid } from './DictionariesConstraintGetEventUuid';
import { DictionariesConstraintGetKnoSupervision } from './DictionariesConstraintGetKnoSupervision';
import { DictionariesDangerClass } from './DictionariesDangerClass';
import { DictionariesDecisionKind } from './DictionariesDecisionKind';
import { DictionariesErvkCheckList } from './DictionariesErvkCheckList';
import { DictionariesErvkControlKindDocTarget } from './DictionariesErvkControlKindDocTarget';
import { DictionariesErvkControlKindNpa } from './DictionariesErvkControlKindNpa';
import { DictionariesGetDictionaryValueIdId } from './DictionariesGetDictionaryValueIdId';
import { DictionariesGetSupervisionDictionaryValueIdId } from './DictionariesGetSupervisionDictionaryValueIdId';
import { DictionariesKnmKind } from './DictionariesKnmKind';
import { DictionariesKnoOrganizations } from './DictionariesKnoOrganizations';
import { DictionariesParticipantPositions } from './DictionariesParticipantPositions';
import { DictionariesPositions } from './DictionariesPositions';
import { DictionariesRequirement } from './DictionariesRequirement';
import { DictionariesRiskCategory } from './DictionariesRiskCategory';
import { DictionariesRiskIndicatory } from './DictionariesRiskIndicatory';
import { DictionariesSubjectKind } from './DictionariesSubjectKind';
import { DictionariesSubjectSubKind } from './DictionariesSubjectSubKind';
import { DictionariesSubjectType } from './DictionariesSubjectType';
import { DictionariesSupervisionType } from './DictionariesSupervisionType';
import { DictionariesTargetEntity } from './DictionariesTargetEntity';
import { FiltersKnmPlan } from './FiltersKnmPlan';
import { GeneralInfoOrganizations } from './GeneralInfoOrganizations';
import { KnmId } from './KnmId';
import { KnmIdHistory } from './KnmIdHistory';
import { isKnmIdCanBeSigned } from './IsKnmIdCanBeSigned';
import { KnmIdLinks } from './KnmIdLinks';
import { KnmInspectors } from './KnmInspectors';
import { KnmPlanAll } from './KnmPlanAll';
import { KnmPlanCheckNotification } from './KnmPlanCheckNotification';
import { KnmPlanId } from './KnmPlanId';
import { KnmPlanIdHistory } from './KnmPlanIdHistory';
import { KnmPlanStatuses } from './KnmPlanStatuses';
import { NewsPublished } from './NewsPublished';
import { ProductionCalendarKnmExcludedDates } from './ProductionCalendarKnmExcludedDates';
import { ProsecutorOrganizationsByKno } from './ProsecutorOrganizationsByKno';
import { PublicPortalUrl } from './PublicPortalUrl';
import { RegistryExportOkved } from './RegistryExportOkved';
import { Settings } from './Settings';
import { SettingsSchedule } from './SettingsSchedule';
import { isSonkoCatalogFindOrg } from './IsSonkoCatalogFindOrg';
import { UserStatusInfoRead } from './UserStatusInfoRead';
import { UsersCurrent } from './UsersCurrent';
import { knmFindIndexesPm } from './knmFindIndexesPm';
import { CatalogsAgreementChangeReasons } from './CatalogsAgreementChangeReasons';

export const MOCKS: { [key: keyof typeof MOCKS_DEFAULT]: unknown } = {};

const MOCKS_DEFAULT: { [key: string]: unknown } = {
  '/public/api/access-manager/api/users/current/extendedprofile': CurrentExtendedprofile,
  '/erknm-catalogs/api/admin/users/current': UsersCurrent,
  '/erknm-catalogs/api/general-info/organizations': GeneralInfoOrganizations,
  '/erknm-catalogs/api/signature/user/status-info-read': UserStatusInfoRead,
  '/erknm-catalogs/api/news/published': NewsPublished,
  '/private/api/admin/news/roles': AdminNewsRoles,
  '/private/api/knm-inspectors': KnmInspectors,
  '/erknm-catalogs/api/catalogs/prosecutor-organizations/by-kno/': ProsecutorOrganizationsByKno,
  '/erknm-knm/api/knm-plan/check-notification': KnmPlanCheckNotification,
  '/erknm-catalogs/api/settings': Settings,
  '/erknm-catalogs/api/settings/schedule': SettingsSchedule,
  '/erknm-catalogs/api/catalogs/rf-districts': CatalogsRfDistricts,
  '/erknm-catalogs/api/catalogs/erknm/countries': CatalogsErknmCountries,
  '/erknm-catalogs/api/catalogs/checklist-answer-types': CatalogsChecklistAnswerTypes,
  '/erknm-catalogs/api/catalogs/knm-document-types': CatalogsKnmDocumentTypes,
  '/erknm-catalogs/api/catalogs/erknm/knm-document-types': CatalogsErknmKnmDocumentTypes,
  '/erknm-catalogs/api/catalogs/erknm/knm-plan-reason-change-types': CatalogsErknmKnmPlanReasonChangeTypes,
  '/erknm-catalogs/api/dictionaries/kno-organizations': DictionariesKnoOrganizations,
  '/erknm-catalogs/api/dictionaries/constraint/get-all-knm-reason-types': DictionariesConstraintGetAllKnmReasonTypes,
  '/erknm-catalogs/api/knm/{id}': KnmId,
  '/erknm-catalogs/api/catalogs/erknm/punishment-nature': CatalogsErknmPunishmentNature,
  '/erknm-catalogs/api/catalogs/knm-remarks': CatalogsKnmRemarks,
  '/erknm-catalogs/api/catalogs/knm-act-type': CatalogsKnmActType,
  '/erknm-catalogs/api/catalogs/knm-canceled-reason': CatalogsKnmCanceledReason,
  '/erknm-catalogs/api/catalogs/erknm/knm-reject-reason-types': CatalogsErknmKnmRejectReasonTypes,
  '/erknm-catalogs/api/catalogs/interaction-category': CatalogsInteractionCategory,
  '/erknm-catalogs/api/catalogs/abrogation-reasons': CatalogsAbrogationReasons,
  '/erknm-catalogs/api/catalogs/erknm/knm-responsible-types': CatalogsErknmKnmResponsibleTypes,
  '/erknm-catalogs/api/catalogs/knm-access-level': CatalogsKnmAccessLevel,
  '/erknm-knm/api/knm/{id}/is-can-be-signed': isKnmIdCanBeSigned,
  '/erknm-catalogs/api/knm/{id}/links': KnmIdLinks,
  '/erknm-catalogs/api/knm-plan/{id}': KnmPlanId,
  '/erknm-catalogs/api/dictionaries/ervk-control-kind-npa': DictionariesErvkControlKindNpa,
  '/erknm-catalogs/api/knm-plan/{id}/history': KnmPlanIdHistory,
  '/erknm-catalogs/api/dictionaries/get-dictionary-value/{id}/{id}': DictionariesGetDictionaryValueIdId,
  '/erknm-catalogs/api/production-calendar/knm-excluded-dates': ProductionCalendarKnmExcludedDates,
  '/erknm-catalogs/api/catalogs/nko-foreign-agents/{id}': CatalogsNkoForeignAgentsId,
  '/erknm-catalogs/api/sonko-catalog/find-org': isSonkoCatalogFindOrg,
  '/erknm-catalogs/api/registry/export/okved': RegistryExportOkved,
  '/erknm-catalogs/api/catalogs/knm-reject-reason-types/{id}': CatalogsKnmRejectReasonTypesId,
  '/erknm-catalogs/api/dictionaries/get-supervision-dictionary-value/{id}/{id}': DictionariesGetSupervisionDictionaryValueIdId,
  '/erknm-catalogs/api/dictionaries/supervision-type': DictionariesSupervisionType,
  '/erknm-catalogs/api/catalogs/erknm/planned-activities': CatalogsErknmPlannedActivities,
  '/erknm-catalogs/api/catalogs/knm-types': CatalogsKnmTypes,
  '/erknm-catalogs/api/dictionaries/check-list': DictionariesCheckList,
  '/erknm-catalogs/api/dictionaries/requirement': DictionariesRequirement,
  '/erknm-catalogs/api/dictionaries/constraint/get-kno-supervision': DictionariesConstraintGetKnoSupervision,
  '/erknm-catalogs/api/dictionaries/accepted-document': DictionariesAcceptedDocument,
  '/erknm-catalogs/api/dictionaries/knm-kind': DictionariesKnmKind,
  '/erknm-catalogs/api/dictionaries/target-entity': DictionariesTargetEntity,
  '/erknm-catalogs/api/dictionaries/ervk-check-list': DictionariesErvkCheckList,
  '/erknm-catalogs/api/dictionaries/constraint/get-available-application-conditions': DictionariesConstraintGetAvailableApplicationConditions,
  '/erknm-catalogs/api/dictionaries/positions': DictionariesPositions,
  '/erknm-catalogs/api/dictionaries/ervk-control-kind-doc-target': DictionariesErvkControlKindDocTarget,
  '/erknm-catalogs/api/dictionaries/participant-positions': DictionariesParticipantPositions,
  '/erknm-catalogs/api/dictionaries/risk-indicatory': DictionariesRiskIndicatory,
  '/erknm-catalogs/api/dictionaries/subject-type': DictionariesSubjectType,
  '/erknm-catalogs/api/dictionaries/subject-kind': DictionariesSubjectKind,
  '/erknm-catalogs/api/dictionaries/subject-sub-kind': DictionariesSubjectSubKind,
  '/erknm-catalogs/api/dictionaries/constraint/get-event-uuid': DictionariesConstraintGetEventUuid,
  '/erknm-catalogs/api/dictionaries/risk-category': DictionariesRiskCategory,
  '/erknm-catalogs/api/dictionaries/danger-class': DictionariesDangerClass,
  '/erknm-catalogs/api/public-portal-url': PublicPortalUrl,
  '/erknm-catalogs/api/knm/{id}/history': KnmIdHistory,
  '/erknm-index/api/knm/find-indexes-pm': knmFindIndexesPm,
  '/erknm-index/api/decision-passport/find-indexes': DecisionPassportFindIndexes,
  '/erknm-catalogs/api/catalogs/judgment/enabled-courts': CatalogsJudgmentEnabledCourts,
  '/erknm-catalogs/api/catalogs/judgment/all-court-levels': CatalogsJudgmentAllCourtLevels,
  '/erknm-catalogs/api/catalogs/erknm/decision-passport/knm-document-types': CatalogsErknmDecisionPassportKnmDocumentTypes,
  '/erknm-knm/api/decision-passport/{id}': DecisionPassportId,
  '/erknm-knm/api/decision-passport/{id}/is-can-be-signed': isDecisionPassportIdIsCanBeSigned,
  '/erknm-catalogs/api/catalogs/judgment/all-cancellation-information': CatalogsJudgmentAllCancellationInformation,
  '/erknm-catalogs/api/catalogs/judgment/all-punishment-index': CatalogsJudgmentAllPunishmentIndex,
  '/erknm-catalogs/api/dictionaries/decision-kind': DictionariesDecisionKind,
  '/erknm-catalogs/api/filters/knm-plan': FiltersKnmPlan,
  '/erknm-index/api/knm-plan/all': KnmPlanAll,
  '/erknm-catalogs/api/catalogs/knm-plan-types': CatalogsKnmPlanTypes,
  '/private/api/catalogs/knm-plan-types': CatalogsKnmPlanTypes,
  '/erknm-catalogs/api/knm-plan/statuses': KnmPlanStatuses,
  '/erknm-knm/api/decision-passport/{id}/history': DecisionPassportIdHistory,
  '/erknm-catalogs/api/catalogs/change-reasons': CatalogsAgreementChangeReasons,
};
